import { useCallback } from 'react';
import PropTypes from 'prop-types';

import Magnifier from '@gef-ui/components/atoms/SvgIcon/Icons/Magnifier';
import Field from '@gef-ui/redux-form/components/Field';

export const TextboxWithSearch = ({ onSearch, fieldName, ...fieldProps }) => {
	const handleSearch = useCallback(() => {
		onSearch();
	}, [onSearch]);

	const handleKeyPressed = useCallback((ev) => {
		if (ev.key === 'Enter') {
			ev.preventDefault();
			ev.stopPropagation();
			this.props.onSearch();
		}
	}, []);

	return (
		<div className="TextboxWithSearch">
			<Magnifier onClick={handleSearch} className="TextboxWithSearch-Icon" />
			<Field {...fieldProps} onKeyPress={handleKeyPressed} fieldName={fieldName} />
		</div>
	);
};

TextboxWithSearch.propTypes = {
	fieldName: PropTypes.string,
	onSearch: PropTypes.func,
};

export default TextboxWithSearch;
